/** Course URLs that 308 to a replacement and must not appear in listings. */
export const VTCT_GHOST_COURSE_PATHS = [
  "/courses/vtct/level-4-diploma-in-advanced-aesthetic-treatments",
  "/courses/vtct/vtct-level-3-award-in-first-aid-at-work",
  "/courses/vtct/level-4-micropigmentation-conversion-training-course",
] as const;

export function normalizeCoursePath(url: string | undefined): string {
  if (!url) return "";
  return url.split("?")[0].replace(/\/+$/, "").toLowerCase();
}

export function isGhostVtctCourse(course: {
  fields?: { url?: string };
}): boolean {
  const url = normalizeCoursePath(course.fields?.url);
  return VTCT_GHOST_COURSE_PATHS.some((path) => url.endsWith(path));
}

export function isGhostVtctCoursePath(url: string | undefined): boolean {
  const normalized = normalizeCoursePath(url);
  return VTCT_GHOST_COURSE_PATHS.some((path) => normalized.endsWith(path));
}
